import axios from '@/api/axios';
import {toQueryString} from '@/api/queryString';
import type {AfriexSubscriptionPlan} from '@/screens/SubscriptionPlans/types';
import type {AdminPaginatedEnvelope, AfriexQueryParams} from '@/types';

export type CreateSubscriptionPlanDTO = Omit<
  AfriexSubscriptionPlan,
  '_id' | 'id' | 'createdAt' | 'updatedAt'
>;

export type UpdateSubscriptionPlanDTO = Omit<
  AfriexSubscriptionPlan,
  | '_id'
  | 'id'
  | 'createdAt'
  | 'updatedAt'
  | 'interval'
  | 'currency'
  | 'features'
>;

export const subscriptionPlanService = {
  getSubscriptionPlans: async (
    filters: AfriexQueryParams,
  ): Promise<AdminPaginatedEnvelope<AfriexSubscriptionPlan[]>> => {
    const urlParams = toQueryString({page: 0, limit: 10, ...filters});
    const url = `/v2/admin/subscription-plans?${urlParams}`;
    const response =
      await axios.get<AdminPaginatedEnvelope<AfriexSubscriptionPlan[]>>(url);
    return response.data;
  },

  getSubscriptionPlanById: async (
    id: string,
  ): Promise<AfriexSubscriptionPlan> => {
    const url = `/v2/admin/subscription-plans/${id}`;
    const response = await axios.get<AfriexSubscriptionPlan>(url);
    return response.data;
  },

  getSubscriptionPlanFeatures: async (): Promise<string[]> => {
    const url = `/v2/admin/subscription-plans/features`;
    const response = await axios.get<string[]>(url);
    return response.data;
  },

  getSubscriptionPlanIntervals: async (): Promise<string[]> => {
    const url = `/v2/admin/subscription-plans/intervals`;
    const response = await axios.get<string[]>(url);
    return response.data;
  },

  createSubscriptionPlan: async (
    formData: CreateSubscriptionPlanDTO,
  ): Promise<AfriexSubscriptionPlan> => {
    const url = `/v2/admin/subscription-plans`;
    const response = await axios.post<AfriexSubscriptionPlan>(url, formData);
    return response.data;
  },

  updateSubscriptionPlan: async (
    id: string,
    formData: UpdateSubscriptionPlanDTO,
  ): Promise<AfriexSubscriptionPlan> => {
    const url = `/v2/admin/subscription-plans/${id}`;
    const response = await axios.patch<AfriexSubscriptionPlan>(url, formData);
    return response.data;
  },

  deleteSubscriptionPlanById: async (
    id: string,
  ): Promise<AfriexSubscriptionPlan> => {
    const url = `/v2/admin/subscription-plans/${id}`;
    const response = await axios.delete<AfriexSubscriptionPlan>(url);
    return response.data;
  },
};
